
import ReviewOptionFieldType from '@/enums/ReviewOptionFieldType';

export default {
  i18nComponentKey: 'ReviewsNew.components.OptionField',
  name: 'OptionField',
  props: {
    optionType: {
      type: Object,
      required: true
    },
    value: {
      type: [String, Number],
      default: null
    },
    invalid: {
      type: Boolean,
      requied: true
    }
  },
  computed: {
    ReviewOptionFieldType: () => ReviewOptionFieldType
  }
};
